// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import xProductPartNumbersStyles from "@west/App/SharedStyles/ProductPartNumbersStyles";
import { productPartNumbersStyles } from "@west/Overrides/Components/ProductPartNumbers";
import { fontConfig } from "@west/XDL/PreStyle/typography";
import { css } from "styled-components";

export const partNumbersStyle: { label?: TypographyProps; value?: TypographyProps } = {
    label: {
        weight: fontConfig.weight.bold,
        size: 14,
        lineHeight: "22px",
        color: "common.ui5",
        css: css`
            flex: 0 0 auto;
            letter-spacing: 0;
            margin-right: 4px;
            padding-left: 0;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        size: 14,
        lineHeight: "22px",
        color: "common.ui5",
        css: css`
            flex: 1 1 auto;
            letter-spacing: 0;
            min-width: 0;
            max-width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        `,
    },
};

productPartNumbersStyles.erpNumberLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.erpNumberValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.customerNameLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.customerNameValueText = {
    ...xProductPartNumbersStyles.value,
};

productPartNumbersStyles.manufacturerItemLabelText = {
    ...xProductPartNumbersStyles.label,
};

productPartNumbersStyles.manufacturerItemValueText = {
    ...xProductPartNumbersStyles.value,
};
